import React from "react"

import { useIntl } from "react-intl"

import CustomBreadcrumb from "../Algolia/Breadcrumb/CustomBreadcrumb"
import Banner from "~/components/Banner/Banner"
import { FormattedBanner } from "~/components/Banner/utils"
import Separator from "~/components/Separator/Separator"
import { Col, Row } from "~/components/ui"
import { Body, Heading } from "~/components/ui/Typography/Typography"
import useCategories from "~/hooks/useCategories"
import { recursiveCategoriesRenaming } from "~/utils/createPages/categoriesUtils"

import css from "./FilteredRecipesHeader.module.scss"

type PropTypes = {
  location: Location
  title: string
  description?: string
  baseHierarchicalFacetsItems: any
  ingredient?: string
  bannerToDisplay: FormattedBanner | null
}

function FilteredRecipesHeader({
  location,
  title,
  description,
  baseHierarchicalFacetsItems,
  ingredient,
  bannerToDisplay,
}: PropTypes) {
  const intl = useIntl()
  const CATEGORIES = useCategories(intl.locale)

  return (
    <>
      <CustomBreadcrumb
        attributes={[
          "categories_tree.lvl0",
          "categories_tree.lvl1",
          "categories_tree.lvl2",
          "categories_tree.lvl3",
        ]}
        transformItems={(items: any) =>
          recursiveCategoriesRenaming(items, CATEGORIES)
        }
        location={location}
        baseItems={baseHierarchicalFacetsItems}
        ingredient={ingredient}
      />
      {!!bannerToDisplay && (
        <Row className={css.banner}>
          <Col width={12}>
            <Banner bannerToDisplay={bannerToDisplay} />
          </Col>
        </Row>
      )}

      <div className={css.title}>
        <Heading variant="extraLarge" Tag="h1">
          {title}
        </Heading>
        {description && <Body variant="body1">{description}</Body>}
      </div>
      <Separator />
    </>
  )
}

export default FilteredRecipesHeader
